import { getNextQuestionId } from "@lrg/lln-quiz-common/lib/learner/lib";

import QuestionsList from './../constants/questions';
import { DEFAULT_QUIZ } from "../constants";
export const getNextQuestionData = async (answer = [], testLevel = DEFAULT_QUIZ) => {
    const data = await getNextQuestionId(testLevel, answer)
    if (data) {
        return QuestionsList[data];
    }
    return null;
};

export const getQuestionDetails = (id) => {
    return QuestionsList[id] || {};
};
